import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'
import React from 'react'

type Props = {
  url: string
  text: string
}

export const ProgramRequestBtn = ({ url, text }: Props): JSX.Element => (
  <div className="flex justify-center items-center mt-[8.3vw] lg:mt-[2.9vw]">
    <a href={url}>
      <div className="w-[87.5vw] lg:w-[28.8vw] h-[13.3vw] lg:h-[4.7vw] bg-gradient-to-r from-primaryTo to-primaryFrom rounded-[11px] lg:rounded-[20px] lg:hover:opacity-50">
        <div className="flex flex-row justify-center items-center h-full">
          <div className="text-[4.5vw] lg:text-[1.3vw] font-bold text-white">
            {text}
          </div>
          <div className="ml-[2vw] lg:ml-[1vw] w-[2.5vw] lg:w-[0.6vw]">
            <ImageWraper
              src={`${cloudfrontPath}/programs/icons/top/right_arrow.svg`}
              alt="右向き矢印のアイコン"
              width={23}
              height={31}
            />
          </div>
        </div>
      </div>
    </a>
  </div>
)
